module.exports = __webpack_public_path__ + "static/media/favicon.c88941e9.ico";